<ul class="horizontal-menu">

  
  <li class="mega-menu">
    <a href="javascript:void(0)" class="nav-link d-xavi" [class.active]="navServices.megaMenu" (click)="megaMenuToggle()">
      <app-feather-icons [icon]="'layers'"></app-feather-icons>
    </a>
    <div class="mega-menu-container nav-submenu menu-to-be-close" [class]="navServices.megaMenu ? 'd-block' : 'd-none'">
      <div class="container-fluid">
        <div class="row">
          <div class="col mega-box mobile-title d-none">
            <h5>SIG-RRHH</h5>
            <app-feather-icons [icon]="'x'" (click)="megaMenuToggle()"></app-feather-icons>
          </div>
          <div class="col mega-box">
            <div class="link-section icon">

              <ul>
                <li>
                  <a [routerLink]="'/detalle/perfil/*'" (click)="megaMenuToggle()">Mi File</a>
                </li>
                <li>
                  <a (click)="open(content);megaMenuToggle()">Cambiar clave</a>
                </li>
                <li>
                  <a href="javascript:void(0);" (click)="salir()">Salir</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>






  <li class="level-menu" *ngIf="habilitar">
    <a class="nav-link" href="javascript:void(0)" [class.active]="navServices.levelMenu" (click)="levelMenuToggle()">
      <app-feather-icons [icon]="'settings'"></app-feather-icons>
      <span>Administración</span>
    </a>
    <ul class="header-level-menu menu-to-be-close" [class]="navServices.levelMenu ? 'd-block' : 'd-none'">

      <li>
        <a href="javascript:void(0);"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}" (click)="levelMenuToggle()">
          <app-feather-icons [icon]="'git-pull-request'"></app-feather-icons>
          <span>Files</span>
        </a>
        <ul class="header-level-sub-menu">
          <li >
            <a [routerLink]="'/detalle/comunicados'"
            (click)="levelMenuToggle()">
              <app-feather-icons [icon]="'clipboard'"></app-feather-icons>
              <span>Comunicados</span>
            </a>
          </li>
          <li >
            <a [routerLink]="'/detalle/archivos'"
            (click)="levelMenuToggle()">
              <app-feather-icons [icon]="'file'"></app-feather-icons>
              <span>Archivos</span>
            </a>
          </li>

        </ul>
      </li>

      <li>
        <a [routerLink]="'/detalle/entidad'" (click)="levelMenuToggle()">
          <app-feather-icons [icon]="'home'"></app-feather-icons>
          <span>Entidades</span>
        </a>
      </li>
      <li>
        <a [routerLink]="'/detalle/unidad'" (click)="levelMenuToggle()">
          <app-feather-icons [icon]="'airplay'"></app-feather-icons>
          <span>Unidades</span>
        </a>
      </li>
      <li *ngIf="_admin || _confuser">
        <a [routerLink]="'/detalle/usuario'" (click)="levelMenuToggle()">
          <app-feather-icons [icon]="'users'"></app-feather-icons>
          <span>Usuarios</span>
        </a>
      </li>
      <li>
        <a [routerLink]="'/detalle/gestion'" (click)="levelMenuToggle()">
          <app-feather-icons [icon]="'calendar'"></app-feather-icons>
          <span>Gestiones</span>
        </a>
      </li>
      <li *ngIf="_admin">
        <a [routerLink]="'/detalle/feriados'" (click)="levelMenuToggle()">
          <app-feather-icons [icon]="'award'"></app-feather-icons>
          <span>Feriados Nal.</span>
        </a>
      </li>
      <li *ngIf="_admin">
        <a [routerLink]="'/detalle/parametrosCAS'" (click)="levelMenuToggle()">
          <app-feather-icons [icon]="'tool'"></app-feather-icons>
          <span>Parametros C.A.S.</span>
        </a>
      </li>
      <li *ngIf="_admin">
        <a href="javascript:void(0)" (click)="open2(content2);levelMenuToggle()">
          <app-feather-icons [icon]="'edit'"></app-feather-icons>
          <span>Parametros</span>
        </a>
      </li>
     

    </ul>
  </li>
</ul>


<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-body">


      <h4 class="modal-title font-primary text-center" id="modal-basic-title">Cambiar Contraseña</h4>

      <br>

           <!-- Form -->
    <form  #usuForm="ngForm" (ngSubmit)="c('Save click')" autocomplete="off">

        <div class="form-row">
          <div class="col-md-12 mb-3">
            <label for="">Contraseña Actual</label>
              <input type="password" class="form-control text-uppercase fuente" name="cla1" [(ngModel)]="claveactual"  placeholder="Contraseña Actual" required>
          </div>
        </div>

        <div class="form-row">
          <div class="col-md-6 mb-3">
              <label for="">Nueva Contraseña</label>
                <input type="password" class="form-control text-uppercase fuente" name="cla2" [(ngModel)]="clavenueva1"  placeholder="Nueva Contraseña" required>
            </div>
          <div class="col-md-6 mb-3">
            <label for="">Repita la contraseña</label>
              <input type="password" class="form-control text-uppercase fuente" name="cla3" [(ngModel)]="clavenueva2"  placeholder="Repita la nueva contraseña" required>
          </div>
          
        </div>
       

        <div class="d-flex justify-content-center">
          <button class="btn btn-primary m-2 btn-sm" type="submit" [disabled]="usuForm.invalid">Guardar</button>
          <button class="btn btn-danger m-2 btn-sm" type="button" (click)="d('Cross click')">Cancelar</button>
        </div>
        
    </form>
    <!-- /form -->


  </div>
</ng-template>


<ng-template #content2 let-c="close" let-d="dismiss">
  <div class="modal-body">


      <h4 class="modal-title font-primary text-center" id="modal-basic-title">Configuración del Sistema</h4>

      <br>

           <!-- Form -->
    <form  #usuForm="ngForm" (ngSubmit)="c('Save click')" autocomplete="off">

        <div class="form-row">
          <div class="col-md-12 mb-3">
            <label for="">Refrigerio por dia trabajado</label>
              <input type="number" class="form-control fuente" name="refri" [(ngModel)]="m_config.refrigerio"  placeholder="Cantidad" required>
          </div>

          <div class="col-md-12 mb-3">
            <label for="">Porcentaje descuento AFP</label>
              <input type="number" class="form-control fuente" name="afp" [(ngModel)]="m_config.descafp"  placeholder="Porcentaje" required>
          </div>

          <div class="col-md-12 mb-3">
            <label for="">Porcentaje descuento IVA</label>
              <input type="number" class="form-control fuente" name="iva" [(ngModel)]="m_config.desciva"  placeholder="Porcentaje" required>
          </div>

          <div class="col-md-12 mb-3">
            <label for="">% Bono frontera</label>
              <input type="number" class="form-control fuente" name="front" [(ngModel)]="m_config.frontera"  placeholder="Cantidad" required>
          </div>

          <div class="col-md-12 mb-3">
            <label for="">Minimo Nacional</label>
              <input type="number" class="form-control fuente" name="mina" [(ngModel)]="m_config.minnacional"  placeholder="Cantidad" required>
          </div>

          <div class="col-md-12 mb-3">
            <label for="">Tipo de Cambio</label>
              <input type="number" class="form-control fuente" name="cambio" [(ngModel)]="m_config.tipocambio"  placeholder="Cantidad" required>
          </div>
        </div>
       

        <div class="d-flex justify-content-center">
          <button class="btn btn-primary m-2 btn-sm" type="submit" [disabled]="usuForm.invalid">Guardar</button>
          <button class="btn btn-danger m-2 btn-sm" type="button" (click)="d('Cross click')">Cancelar</button>
        </div>
        
    </form>
    <!-- /form -->


  </div>
</ng-template>